export default __webpack_public_path__ + "c80f9eb1de91711b8472c7122fc1ab98.png";